module.exports = __webpack_public_path__ + "static/media/stepper-minus.ff2577c8.svg";